import { useEffect } from 'react'

import { useProposal, useLead } from '@itau-loans-www/hooks'
import { http, sdkAnalytics } from '@itau-loans-www/services'
import { goTo, getDevice, isClient } from '@itau-loans-www/utils'
import platform from 'platform'

export const useAuthorizeFgts = () => {
  const { loading, setIsLoading } = useProposal()
  const { os } = platform
  const {
    leadData: { partner },
    changeLeadData
  } = useLead()

  const alreadyAuthorized = async () => {
    setIsLoading(true)
    return http.fgts
      .putFgtsAllowed()
      .then(({ next_step, final_screen }) => {
        if (!final_screen) return goTo(next_step)
        changeLeadData({ tracking: { isFromAllowFGTSAppStep: true } })
        goTo(final_screen)
      })
      .catch(() => {
        if (partner && partner !== 'magalu') {
          return goTo('final-screen-fgts-partner-ineligible')
        }

        goTo('final-screen-fgts-ineligible')
      })
  }

  const getLink = () => {
    const isMobile = getDevice.isMobile()
    const link = {
      desktop:
        'https://www.caixa.gov.br/atendimento/aplicativos/fgts/Paginas/default.aspx',
      Android:
        'https://play.google.com/store/apps/details?id=br.gov.caixa.fgts.trabalhador',
      iOS: 'https://apps.apple.com/br/app/fgts/id1038441027'
    }

    if (!isMobile) return link.desktop

    return link[os.family]
  }

  const knowMore = () => {
    sdkAnalytics.track('trackClick', 'btn:acessar-app')

    if (isClient()) {
      const link = getLink()
      window.open(link, '_blank')
    }
  }

  const carouselConfig = {
    infinite: false,
    slidesToShow: 2.5,
    slidesToScroll: 1,
    lazyLoad: true,
    responsive: [
      {
        breakpoint: 576,
        settings: {
          infinite: false,
          slidesToShow: 1.25,
          slidesToScroll: 1
        }
      }
    ]
  }

  useEffect(() => {
    setIsLoading(false)
  }, [setIsLoading])

  return { loading, alreadyAuthorized, knowMore, carouselConfig }
}
